import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { createLocation } from 'history';
import { Location, LocationState } from 'types';

export const useRedirect = (route: string, saveCurrentLocation = false): Location => {
  const location = useLocation<LocationState>();

  const newlocation = useMemo<Location>(() => {
    if (saveCurrentLocation) {
      return createLocation(route, { lastLocation: location });
    }

    return location?.state?.lastLocation || createLocation(route);
  }, [route, saveCurrentLocation]);

  return newlocation;
};
